import { campaignTemplateStandardColumn } from "@specsheet-common/shared-types";

export const editableStandardColumns = new Set<string>([
  campaignTemplateStandardColumn.NOTES,
  campaignTemplateStandardColumn.CREATIVE,
  campaignTemplateStandardColumn.DISPATCH_DATE,
  campaignTemplateStandardColumn.DISPATCH_DETAILS,
  campaignTemplateStandardColumn.LIVE_DATE,
  campaignTemplateStandardColumn.END_DATE,
  campaignTemplateStandardColumn.PUBLICATIONS,
  campaignTemplateStandardColumn.REQUIRED_DURATION,
]);
